module.exports = __webpack_public_path__ + "img/banner-swiper2-hen.1a78f434.png";